module.exports = __webpack_public_path__ + "static/media/pin.8a366b70.svg";